import React, { useCallback } from "react";

import { IActionTeachingMaterial, IActionLessons } from "../../../../state";
import { ReactComponent as CheckIcon } from "../../../../assets/svg/check.svg";

import styles from "./VolumeList.module.scss";

export interface IVolumeListProps {
  activeVolume: string | null;
  setActiveVolume: React.Dispatch<React.SetStateAction<string | null>>;
  volumeList: IActionTeachingMaterial[];
  hasAnsweredLessons: (volume: IActionTeachingMaterial) => boolean;
}

const VolumeList: React.FC<IVolumeListProps> = ({
  activeVolume,
  setActiveVolume,
  volumeList,
  hasAnsweredLessons,
}) => {
  // 既存の反省内容チェック（チェックマーク表示用）
  const allReflectionsComplete = useCallback(volume => {
    if (!volume.lessons || volume.lessons.length === 0) {
      return false;
    }
    return volume.lessons.every(
      (lesson: IActionLessons) =>
        lesson.reflection_realization_reference !== null,
    );
  }, []);

  return (
    <div>
      {volumeList.map(volume => (
        <div
          className={`${styles.volumeContainer} ${
            activeVolume === volume.name && hasAnsweredLessons(volume)
              ? styles.selectedVolume
              : ""
          } ${
            hasAnsweredLessons(volume) ? "" : styles.volumeContainerDisabled
          }`}
          onClick={() => {
            if (hasAnsweredLessons(volume)) {
              setActiveVolume(volume.name);
            }
          }}
          key={volume.id}
        >
          <div className={styles.imageContainer}>
            <img src={volume.image_url} alt="" className={styles.volumeImage} />
            {allReflectionsComplete(volume) && (
              <CheckIcon className={styles.checkIcon} />
            )}
          </div>
          <span
            className={`${
              volume.lessons && volume.lessons.length > 0
                ? styles.volumeTitle
                : styles.disabledVolume
            }`}
          >
            {volume.name}
          </span>
        </div>
      ))}
    </div>
  );
};

export default VolumeList;
